import { Controller } from '@hotwired/stimulus';
import Leaflet from 'leaflet';

export default class extends Controller {
    connect() {
        const address = this.element.dataset.address ? this.element.dataset.address : '';
        const coords = this.element.dataset.coords ? this.element.dataset.coords.split(',') : [0, 0];
        const map = Leaflet.map(this.element, {
            center: coords,
            zoom: 16,
            scrollWheelZoom: false,
        });

        Leaflet.tileLayer('https://api.mapbox.com/styles/v1/{id}/tiles/{z}/{x}/{y}?access_token={accessToken}', {
            attribution: '',
            id: 'demovilius/cln4cbf0z036m01quhs2v4byj',
            tileSize: 512,
            zoomOffset: -1,
            accessToken: 'pk.eyJ1IjoiZGVtb3ZpbGl1cyIsImEiOiJjbG40YzlzM2wwc2wxMnFtdWhoYTZzMGxqIn0.Y4Srcx-gw59R_j8uv1fgLQ',
        }).addTo(map);

        // eslint-disable-next-line @babel/new-cap
        new Leaflet.popup({
            closeOnClick: false,
            autoClose: false,
            closeButton: false,
            closeOnEscapeKey: false,
            keepInView: true,
        }).setContent(`<p>${address}</p>`)
            .setLatLng(coords)
            .openOn(map);
    }
}
